/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { setUserData } from '../../store/ducks/AuthDuck';
import { useDispatch } from 'react-redux';
import useModal from '../../hooks/useModal';
import Modal from '../../components/modal/Modal';
import uploadToS3Bucket from '../../utils/uploadToS3Bucket';
import { useMutateUserProfile } from '../../hooks/api/useUserProfile';
import CardDelete from '../../components/cards/CardDelete';
import CardEditPicture from '../../components/cards/CardEditPicture';
import AlertCustom from '../../components/alert/AlertCustom';
import Button from '../../components/button/Button';
import Loading from '../../components/loading/Loading';

const useEditPictures = props => {
    const [isOpenEdit, closeEdit, openEdit] = useModal();
    const [isOpenDelete, closeDelete, openDelete] = useModal();
    const [isAlert, closeAlert, openAlert] = useModal();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const pictureType = props?.isCover ? 'cover' : 'profile';

    const { mutate } = useMutateUserProfile();
    const updateData = picture => {
        const data = { [`${pictureType}Picture`]: picture };
        mutate(data, {
            onSuccess: () => {
                setLoading(false);
                closeEdit();
                setTimeout(() => {
                    openAlert();
                }, 200);
            }
        });
        dispatch(setUserData(data));
    };
    const onChangeFile = async file => {
        try {
            let picture;
            setLoading(true);
            uploadToS3Bucket(file)
                .then(data => {
                    picture = data.location;
                })
                .catch(err => console.error('error uploading', err))
                .finally(() => {
                    console.log('finally', picture);
                    updateData(picture);
                });
        } catch (error) {
            console.log(error);
        }
    };
    const deletePicture = async () => {
        try {
            setLoading(true);
            closeDelete();
            updateData(null);
        } catch (error) {
            console.log(error);
        }
    };

    const modalProps = {
        isOpenEdit,
        closeEdit,
        pictureType,
        onChangeFile,
        openDelete,
        closeDelete,
        isOpenDelete,
        isAlert,
        closeAlert,
        loading,
        deletePicture
    };
    const jsx = <ModalEditPictures {...modalProps} />;

    return [openEdit, jsx];
};

export default useEditPictures;

const ModalEditPictures = ({
    isOpenEdit,
    closeEdit,
    pictureType,
    onChangeFile,
    openDelete,
    closeDelete,
    isOpenDelete,
    isAlert,
    closeAlert,
    loading,
    deletePicture
}) =>
    loading ? (
        <Loading />
    ) : (
        <>
            <Modal
                showModal={isOpenEdit}
                closeModal={closeEdit}
                position="p-medium"
                width="modal-xs">
                <CardEditPicture
                    pictureType={pictureType}
                    onChangeFile={onChangeFile}
                    openDelete={openDelete}
                    closeEdit={closeEdit}
                />
            </Modal>
            <Modal
                showModal={isOpenDelete}
                closeModal={closeDelete}
                position="p-medium"
                width="modal-xs">
                <CardDelete
                    pictureType={pictureType}
                    closeDelete={closeDelete}
                    deletePicture={deletePicture}
                />
            </Modal>
            <AlertCustom
                showModal={isAlert}
                title="Saved successfully"
                subtitle="Picture information has been saved successfully"
                typeAlert="success">
                <Button
                    classs="btnMain"
                    text="Ok"
                    onClick={() => {
                        closeAlert();
                    }}
                />
            </AlertCustom>
        </>
    );
